require("core-js/modules/es.array.reduce.js");

var _require = require('./sitelinks'),
    getSitelinkUrl = _require.getSitelinkUrl;

module.exports = function (sitelinks) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var addUrl = options.addUrl;
  return Object.keys(sitelinks).reduce(aggregateValues(sitelinks, addUrl), {});
};

var aggregateValues = function aggregateValues(sitelinks, addUrl) {
  return function (index, key) {
    // Accomodating for wikibase-cli, which might set the sitelink to null
    // to signify that a requested sitelink was not found
    if (sitelinks[key] == null) {
      index[key] = sitelinks[key];
      return index;
    }

    var title = sitelinks[key].title;

    if (addUrl) {
      index[key] = {
        title: title,
        url: getSitelinkUrl(key, title)
      };
    } else {
      index[key] = title;
    }

    return index;
  };
};